(() => {
  const today = new Date().toISOString().slice(0, 10);
  const visitKey = 'originaria-first-visit';
  let firstVisitedOn = today;
  try {
    const saved = localStorage.getItem(visitKey);
    if (/^\d{4}-\d{2}-\d{2}$/.test(saved || '') && saved <= today && !Number.isNaN(Date.parse(saved + 'T00:00:00Z')) && new Date(saved + 'T00:00:00Z').toISOString().slice(0, 10) === saved) firstVisitedOn = saved;
    localStorage.setItem(visitKey, firstVisitedOn);
  } catch { /* The current visit remains available when browser storage is disabled. */ }
  window.OriginariaVisit = Object.freeze({ firstVisitedOn });
  const init = (scope) => {
    scope.querySelectorAll('a[href]').forEach((link) => {
      try {
        const target = new URL(link.href, location.href);
        if (target.origin === 'https://litq-registration-916444921783.southamerica-east1.run.app' && ['/register', '/guestbook'].includes(target.pathname)) {
          target.searchParams.set('firstVisit', firstVisitedOn);
          link.href = target.href;
        }
      } catch { /* Leave unrelated links unchanged. */ }
    });
    scope.querySelectorAll('[data-originaria-nav]').forEach((nav) => {
      if (nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      const dropdowns = Array.from(nav.querySelectorAll('[data-originaria-dropdown]'));
      const closeOthers = (current) => {
        dropdowns.forEach((dropdown) => {
          if (dropdown !== current) dropdown.open = false;
        });
      };

      dropdowns.forEach((dropdown) => {
        const summary = dropdown.querySelector('summary');
        dropdown.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'touch' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          closeOthers(dropdown);
          dropdown.open = true;
        });
        dropdown.addEventListener('pointerleave', () => {
          if (!dropdown.contains(document.activeElement)) dropdown.open = false;
        });
        dropdown.addEventListener('focusout', (event) => {
          if (!dropdown.contains(event.relatedTarget)) dropdown.open = false;
        });
        dropdown.addEventListener('toggle', () => {
          if (dropdown.open) closeOthers(dropdown);
        });
        summary.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowDown') return;
          event.preventDefault();
          closeOthers(dropdown);
          dropdown.open = true;
          dropdown.querySelector('a')?.focus();
        });
      });

      document.addEventListener('pointerdown', (event) => {
        if (!nav.contains(event.target)) closeOthers();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const current = dropdowns.find((dropdown) => dropdown.open && dropdown.contains(document.activeElement));
        if (current) {
          event.preventDefault();
          current.querySelector('summary').focus();
        }
        closeOthers();
      });
    });
  };

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
